export default __webpack_public_path__ + "static/media/down_arrow.25e80820.svg";